import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";

// Structure du vin
type Vin = {
    Id: number;
    Appellation: string;
    Millesime: string;
    NomDuDomaine: string;
    NomDeCuvee?: string;
    Description: string;
    Prix: string;
    Contenance: string;
    Alcool: string;
};

// Structure du lien
type Lien = {
    Id: number;
    Lien: string;
};

function VinDetails() {
    const { type, id } = useParams<{ type: string; id: string }>(); // Récupère le type et l’ID dans l’URL
    const [vin, setVin] = useState<Vin | null>(null);
    const [lien, setLien] = useState<string | null>(null);

    useEffect(() => {
        const loadData = async () => {
            try {
                const vinResponse = await fetch(`/data/DB_vin_${type}.json`);
                const lienResponse = await fetch(`/data/DB_vin_${type}_lien.json`);

                const vinsData: Vin[] = await vinResponse.json();
                const liensData: Lien[] = await lienResponse.json();

                const vinTrouve = vinsData.find((v) => v.Id === Number(id));
                const lienTrouve = liensData.find((l) => l.Id === Number(id));

                setVin(vinTrouve || null);
                setLien(lienTrouve?.Lien || null);
            } catch (err) {
                console.error("Erreur chargement vin :", err);
            }
        };

        loadData();
    }, [type, id]);

    if (!vin) return <p>Chargement ou vin introuvable...</p>;

    return (
        <div style={{ padding: "1rem" }}>
            <h2>{vin.NomDuDomaine} - {vin.Appellation} ({vin.Millesime})</h2>
            {vin.NomDeCuvee && <h4>{vin.NomDeCuvee}</h4>}
            <p>{vin.Description}</p>
            <p><strong>Prix :</strong> {vin.Prix}</p>
            <p><strong>Contenance :</strong> {vin.Contenance}</p>
            <p><strong>Alcool :</strong> {vin.Alcool}</p>
            {lien ? (
                <a href={lien} target="_blank" rel="noreferrer">Voir ou acheter 🍷</a>
            ) : (
                <p style={{ color: "red" }}>Lien indisponible</p>
            )}
        </div>
    );
}

export default VinDetails;
